/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";


const Tarjeta_Contacto_Home = ({icono_correo, contacto}) => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container
                   justifyContent={'center'}
                   size={12}
                   sx={{height: 94}}>
                <img

                    src={icono_correo} width={'auto'} height={70}

                />
            </Grid2>
            <Grid2 container
                   justifyContent={'center'}
                   size={12}>
                <Typography
                    sx={{fontSize: 20, fontWeight: 700, textAlign: 'center', height: 70,}}>{contacto}</Typography>
            </Grid2>

        </Grid2>

    )

}
export default Tarjeta_Contacto_Home